import entityList from "./entityList";
import entityRow from "./entityRow";
import entityListSearch from "./entityListSearch";

export default `
${entityListSearch}
${entityRow}
${entityList}
`;
